import { render, staticRenderFns } from "./MetaConfig.vue?vue&type=template&id=223c6c04&"
import script from "./MetaConfig.vue?vue&type=script&lang=js&"
export * from "./MetaConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports